<div class="grid">
  <div class="grid__col-12">
    <div class="no-results crap">
      <img
        *ngIf="emptyImageURL"
        [src]="emptyImageURL"
        [alt]="i18n.Core_Empty_Image_Alt"
      />
      <h1 class="h1 guts-p-b-half guts-m-t-2">
        {{ i18n.LearningSearch_Hmm }}
      </h1>
      <h2 class="h2 guts-p-b-2-half">
        {{ i18n.LearningSearch_ProviderNotPartOfCatalog }}
      </h2>
      <p class="par">
        {{ i18n.LearningSearch_ProviderNoResultsFoundAdvice }}
      </p>
    </div>
  </div>
</div>
